import React, { useEffect } from 'react';
import { colors } from '@/globalStyles';
import { getElementByGetElementById } from '@/helpers';
import PxcLogoIcon from '../../../assets/icons/logo-pxc-contact.inline.svg';

const PxcLogoComponent = props => {
  const { id, primitiveProps, style } = props;
  const { x: x, y: y, w: width, h: height, invert_color = false } = primitiveProps;

  if (style) {
    delete style.fill;
    delete style.stroke;
    delete style.strokeWidth;
    style.pointerEvents = 'none';
    style.fill = invert_color ? colors.white : colors.black;
  }

  useEffect(() => {
    const obj = getElementByGetElementById(id);
    if (obj) {
      const viewBox = obj.getAttribute('viewBox').split(' ');
      if (obj.parentElement && viewBox) {
        const should_rotate = viewBox?.length === 4 && Number(viewBox[2]) > Number(viewBox[3]) && width < height;
        if (should_rotate) {
          obj.parentElement.setAttribute('transform', `translate(${width}, 0) rotate(90 ${x} ${y})`);
          obj.setAttribute('width', height);
          obj.setAttribute('height', width);
        }
      }
    }
  });

  return (
    <g id={`group-${id}`}>
      <PxcLogoIcon id={id} x={x} y={y} width={width} height={height} style={style} />
    </g>
  );
};

export default PxcLogoComponent;
